import Spinning from "./spinning";

export default function LoadingMain() {
  return (
    <div className="flex justify-center items-center h-screen"><Spinning/></div>
  )
}

